"use client"

import { SunIcon } from "@/icons/outline/SunIcon"
import { MoonIcon } from "@/icons/solid/MoonIcon"
import { useTheme } from "./ThemeContext"
import { useEffect } from "react"

export const ThemeSwitch = () => {
  const { toggleTheme } = useTheme()

  const { theme } = useTheme()

  useEffect(() => {
    if (theme === "dark") {
      document.body.style.backgroundColor = "#110F10"
    } else {
      document.body.style.backgroundColor = "#F1F1F1"
    }
  }, [theme])

  return (
    <div
      className="group relative size-14 cursor-pointer overflow-hidden rounded-xl border border-[#363435] bg-marketing-background-1-light/50 transition-all duration-300 ease-in-out group-hover:border-marketing-secondary dark:bg-marketing-background-1-dark/50"
      style={{
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
      }}
      onClick={toggleTheme}>
      <div className="absolute -top-[54px] left-0 flex flex-col transition-all duration-500 ease-in-out group-hover:translate-y-1/2 dark:top-0 dark:group-hover:-translate-y-1/2">
        <div className="flex size-[54px] items-center justify-center">
          <MoonIcon className="size-[22px] fill-marketing-primary-light dark:fill-marketing-primary-dark" />
        </div>
        <div className="flex size-[54px] items-center justify-center">
          <SunIcon className="size-6 stroke-marketing-primary-light dark:stroke-marketing-primary-dark" />
        </div>
      </div>
    </div>
  )
}
